import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faTrash } from "@fortawesome/free-solid-svg-icons";
import Pagination_Holder from "../../../../../common/common_components/pagination_holder/Pagination_Holder";
import { useDispatch, useSelector } from "react-redux";
import {
  GetAll,
  Status,
  Delete,
} from "../../../../../features/admin/masters/prefferedcommunicationmode/Slice";
import { FixIDS } from "../../../../../utils/fixIDS";
import { IDS } from "../../../../../utils/IDS";
import { Form, Modal } from "react-bootstrap";
import "./Parent.css";
import Success_Toster from "../../../../../common/common_modal/success_toster/Success_Toster";

const Table = ({ setEdit, setEditId, searchName }) => {
  const alldata = useSelector(
    (state) => state.masters.preffered_communication_mode,
  );
  const dispatch = useDispatch();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const [onPageChange, setonPageChange] = useState(1);
  const permissions = useSelector((state) => state.auth.permissions);

  const haveEditPermission = permissions?.includes(
    FixIDS.preffered_communication_mode.Edit,
  );

  const haveDeletePermission = permissions?.includes(
    FixIDS.preffered_communication_mode.Delete,
  );

  useEffect(() => {
    fetch(onPageChange);
  }, [searchName, onPageChange]);

  const fetch = async (page = 1) => {
    await dispatch(
      GetAll({
        name: searchName,
        page: page,
        per_page: alldata?.per_page,
      }),
    );
  };

  const openDeleteModal = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setDeleteId(null);
    setShowDeleteModal(false);
  };
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => setSuccess(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [success]);
  const confirmDelete = async () => {
    if (!deleteId) return;

    try {
      await dispatch(Delete(deleteId));
      setSuccess(true);
      fetch(onPageChange); // refresh table
    } catch (error) {
      console.error(error);
    } finally {
      closeDeleteModal();
    }
  };

  const toggleStatus = async (id) => {
    try {
      await dispatch(Status(id));
      fetch();
      return true; // Success
    } catch (error) {
      console.error(error);
      return false; // Error
    }
  };

  const handlePageChange = (page) => {
    setonPageChange(page);
  };

  const getStatusClass = (status) => {
    if (status === true || status === "true" || status === 1) return "green";
    if (status === false || status === "false" || status === 0) return "red";
    return "";
  };

  const handleStatusChange = async (id) => {
    const success = await toggleStatus(id);
    // if (success) setSuccess(true);
    // else setErr(true);
  };

  return (
    <>
      <div className="common_table_container theme_bg">
        <div className="table-responsive">
          <table className="common_table table table-striped">
            <thead>
              <tr>
                <th>Sr. No</th>
                <th>Name</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {Array.isArray(alldata?.data) && alldata.data.length > 0 ? (
                alldata.data.map((row, index) => (
                  <tr key={index} className={index % 2 !== 0 ? "striped" : ""}>
                    <td>
                      {(alldata?.current_page - 1) * (alldata?.per_page || 0) +
                        index +
                        1}
                    </td>
                    <td>{row?.name || "-"}</td>
                    <td>
                      <Form.Check
                        type="switch"
                        id={`custom-switch-${row?.id}`}
                        checked={row?.status}
                        onChange={() => handleStatusChange(row?.id)}
                        label={row?.status ? IDS.ACTIVE : IDS.INACTIVE}
                      />
                    </td>

                    <td className="text-center">
                      <div
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "50px",
                        }}
                      >
                        {/* EDIT */}
                        {haveEditPermission && (
                          <span
                            onClick={() => {
                              setEditId(row?.id);
                              setEdit(true);
                            }}
                            title="Edit"
                            style={{ cursor: "pointer" }}
                          >
                            <FontAwesomeIcon icon={faPencil} size="lg" />
                          </span>
                        )}

                        {/* DELETE */}
                        {haveDeletePermission && (
                          <span
                            onClick={() => openDeleteModal(row?.id)}
                            title="Delete"
                            style={{ cursor: "pointer", color: "#dc3545" }}
                          >
                            <FontAwesomeIcon icon={faTrash} size="lg" />
                          </span>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="text-center">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">
            Showing {(alldata?.current_page - 1) * alldata?.per_page + 1} To{" "}
            {Math.min(
              alldata?.current_page * alldata?.per_page,
              alldata?.total,
            )}{" "}
            Of {alldata?.total} Entries
          </p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={alldata?.current_page}
            totalPages={alldata?.total_pages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>

      <Modal show={showDeleteModal} onHide={closeDeleteModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>

        <Modal.Body>Are you sure you want to delete this data?</Modal.Body>

        <Modal.Footer>
          <button className="btn btn-secondary" onClick={closeDeleteModal}>
            No
          </button>

          <button className="btn btn-danger" onClick={confirmDelete}>
            Yes, Delete
          </button>
        </Modal.Footer>
      </Modal>
      {success && <Success_Toster successText="Data Delete successfully!" />}
    </>
  );
};

export default Table;
